module.exports = __webpack_public_path__ + "assets/img/sirius_courses_logo_small_white.svg";